// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bib_j bib_i bib_bc bib_r bib_st","QualityCheckboxes__quality":"ex_b"};